import { render, staticRenderFns } from "./Salida.vue?vue&type=template&id=20ea7e75&"
import script from "./Salida.vue?vue&type=script&lang=js&"
export * from "./Salida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports